import { makePageSingleton } from '@app/adapters/singleton/page'

// Contract with the Solid SPA (silverfin-solid SDK): the SPA dispatches this
// event on `document` after evaluating the template's `<handle>.Reconciled`
// fact, and again whenever the value changes.
export const RECONCILED_STATUS_EVENT = 'solid:reconciled-status'

export interface ReconciledStatusDetail {
  reconciled: boolean
}

// Records the latest reconciled status reported by the SPA, so a consumer
// that subscribes after the SPA's first emit (Stimulus only connects
// controllers at DOM-ready, while the SPA boots from its own module script)
// can still read it. Started eagerly from the application entry, which
// evaluates before the SPA's deferred module script can emit.
export class ReconciledStatusService {
  #lastKnownDetail: ReconciledStatusDetail | null = null

  constructor() {
    document.addEventListener(RECONCILED_STATUS_EVENT, this.#record)
  }

  get lastKnownDetail(): ReconciledStatusDetail | null {
    return this.#lastKnownDetail
  }

  // Gets called automatically when the page changes, so a status recorded on
  // one page is never replayed on another.
  teardown = (): void => {
    document.removeEventListener(RECONCILED_STATUS_EVENT, this.#record)
    this.#lastKnownDetail = null
  }

  #record = (event: Event): void => {
    this.#lastKnownDetail = (
      event as CustomEvent<ReconciledStatusDetail>
    ).detail
  }
}

export default makePageSingleton(() => new ReconciledStatusService())
